import { render, staticRenderFns } from "./GatewayDetailOverview.vue?vue&type=template&id=506e5e7e&scoped=true&lang=html&"
import script from "./GatewayDetailOverview.vue?vue&type=script&lang=ts&"
export * from "./GatewayDetailOverview.vue?vue&type=script&lang=ts&"
import style0 from "./GatewayDetailOverview.vue?vue&type=style&index=0&id=506e5e7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e5e7e",
  null
  
)

export default component.exports